import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { Block } from 'slate';
import { Editor } from 'slate-react';
import getBlockClassName from '../../utils/getBlockClassName';
import toggleTodo from '../utils/toggleTodo';
import getBlockId from '../../../utils/getBlockId';
import './style.css';

var TodoBlock =
/*#__PURE__*/
function (_Component) {
  _inherits(TodoBlock, _Component);

  function TodoBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TodoBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TodoBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          editor = _this$props.editor,
          node = _this$props.node;

      if (editor.readOnly) {
        return false;
      }

      toggleTodo(editor, node);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    return _this;
  }

  _createClass(TodoBlock, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          attributes = _this$props2.attributes,
          node = _this$props2.node,
          editor = _this$props2.editor,
          children = _this$props2.children;
      var checked = node.data.get('checked') || false;
      var className = classNames(getBlockClassName(node), 'todo-block', 'flexbox flexbox-align-start', {
        checked: checked
      });
      return React.createElement("div", Object.assign({}, attributes, {
        className: className,
        "data-block-id": getBlockId(node)
      }), React.createElement("span", {
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        className: "todo-block-input-wrapper position-relative flexbox flexbox-align-center",
        contentEditable: false
      }, React.createElement("input", {
        type: "checkbox",
        className: classNames({
          pointer: !editor.readOnly
        }),
        checked: checked,
        readOnly: true
      })), React.createElement("div", {
        className: "todo-block-text flexbox-grow"
      }, children));
    }
  }]);

  return TodoBlock;
}(Component);

_defineProperty(TodoBlock, "propTypes", {
  node: PropTypes.instanceOf(Block).isRequired,
  editor: PropTypes.instanceOf(Editor).isRequired,
  attributes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired
});

export default TodoBlock;